// extracted by mini-css-extract-plugin
export default {"loadingSpinner":"styles_loadingSpinner","svgPath":"styles_svgPath","rotate":"styles_rotate","container":"styles_container","loader":"styles_loader","spin":"styles_spin"};